import documentTypeIds from "constants/documentTypeIds";

export const getPartnerFileNextStates = (state, documentId, siteId) => {
  const item = state.partnerFiles.partnerFileNextStates[`${documentId}-${siteId}`];
  const loaded = Boolean(item?.loaded);
  const loading = Boolean(item?.loading);
  const content = loaded ? item : [];

  return { loading, loaded, content };
};

export const getPartnerFileHeader = (state, documentId, siteId) => {
  let key = `${documentId}-${siteId}`;
  const partnerFileHeader = state.partnerFiles.item[key] ? state.partnerFiles.item[key] : null;

  const loading = Boolean(partnerFileHeader?.loading);
  const loaded = Boolean(partnerFileHeader?.loaded);
  const content = loaded ? partnerFileHeader : {};

  return { loading, loaded, content: { ...content, documentTypeId: documentTypeIds.PartnerFile } };
};

export const getPartnerFileData = (state) => {
  return state.partnerFiles.currentFile;
};